module.exports = __webpack_public_path__ + "img/legal-small.ff7863d8.webp";